import React from 'react';
import { Button, FormGroup } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
import moment from 'moment';
import DobInput from '../Components/DobInput';
import MobileHeader from '../Components/MobileHeader';
import KioskOutcome from '../Components/KioskOutcome';
import FormValidator from '../Components/FormValidator';
import { apiService } from '../Services/summonsAPI';
import { globals } from '../Services/globals';
import ErrorMessage from './ErrorMessage';
import Questionnaire from './Questionnaire';
import CheckIn from './CheckIn';
import DeniedDeferment from './DeniedDeferment';
import Notifications from '../notifications/Notifications';

import 'react-datepicker/dist/react-datepicker.css';

const kioskMode = !!window.location.search.match(/kiosk/);
const idledOut = !!window.location.search.match(/idle/);

function isEmpty(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}

export default class test extends React.Component {
    constructor(props) {
        super(props);

        this.validator = new FormValidator([
            {
                field: 'jurorDOB',
                method: 'isEmpty',
                validWhen: false,
                message: 'Juror DOB is required.'
            },

            {
                field: 'jurorID',
                method: 'isEmpty',
                validWhen: false,
                compareRequireField: 'jurorDL',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Juror ID is required.'
            },
            {
                field: 'jurorID',
                method: 'isLength',
                args: [{ min: 7, max: 7 }],
                validWhen: true,
                compareRequireField: 'jurorDL',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Enter Juror ID including leading zeros.'
            },
            {
                field: 'jurorID',
                method: 'isNumeric',
                validWhen: true,
                compareRequireField: 'jurorDL',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Juror ID is numeric.'
            },

            {
                field: 'jurorDL',
                method: 'isEmpty',
                validWhen: false,
                compareRequireField: 'jurorID',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Driver License is required.'
            },
            {
                field: 'jurorDL',
                method: 'isNumeric',
                validWhen: true,
                compareRequireField: 'jurorID',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Driver License# is numeric'
            },
            {
                field: 'jurorDL',
                method: 'isLength',
                args: [{ min: 7, max: 9 }],
                validWhen: true,
                compareRequireField: 'jurorID',
                compareRequireMethod: 'isEmpty',
                compareRequireWhen: true,
                message: 'Enter Driver License including leading zeros.'
            }
        ]);

        this.state = {
            loginType: 'jid',
            jurorDOB: '',
            jurorID: '',
            jurorDL: '',
            juror: '',
            authenticateFlag: '',

            connectAPI: true,
            generalError: false,
            validation: this.validator.valid(),

            isSpecial: false
        };

        this.baseState = this.state;
        this.logOut = this.logOut.bind(this);
        this.dataReview = this.dataReview.bind(this);
    }

    componentDidMount = () => {
        // this.datePicker.input.setAttribute('autocomplete', 'off');
    };

    getJurorInfo = async () => {
        try {
            const data = await apiService.getSummonsRecipientLogin(moment(this.state.jurorDOB).format('L'), this.state.jurorID, this.state.jurorDL);
            const actualData = await data.json();

            if (actualData.currentPoolID) {
                const specialData = await apiService.getJuryPool(actualData.currentPoolID).then((res) => res.json());

                this.setState({ isSpecial: specialData.specialTrial });
            }

            /* if there there juror info, but no status */
            if (!isEmpty(actualData) && !actualData.status) {
                actualData.status = { jurorStatus: 1, jurorStatusAlias: 'questionnaireIncomplete' };
                this.setState({ juror: actualData, generalError: true });
            }

            /** set juror */
            this.setState({ juror: actualData });
            this.setState({ connectAPI: true });
        } catch (e) {
            console.warn(e);
            this.setState({ connectAPI: false });
        }

        /* authenticateFlag
        0 = invalid
        1 = authenicate - proceed to questionaire
        */
        // if connected
        if (this.state.connectAPI) {
            if (this.state.juror.jurorID === undefined) {
                this.setState({ authenticateFlag: 0 });
            } else {
                //* there is juror ID, proceed to next step */

                this.setState({ authenticateFlag: 1 });
                globals.juror = this.state.juror;
            }
        } else {
            this.setState({ authenticateFlag: -1 });
        }
    };

    /* Questionnaire complete, get juror information status again, and render base on the current status if need */
    /* questionnaire going to send back 2/3 for status, and possbily deferReason */
    dataReview = async (statusAlias, deferReasonCode) => {
        /* set juror status  */
        const updateJuror = this.state.juror;
        updateJuror.possibleDefermentCodeID = deferReasonCode;
        updateJuror.status.jurorStatusAlias = statusAlias;

        /* Post the juror status */
        let postResult;
        try {
            postResult = await (
                await apiService.postQuestionnaireEnd(updateJuror).catch((err) => {
                    const msgs = {
                        AbortError: 'Request timed out',
                        Unknown: 'Unknown error'
                    };
                    return new Response(
                        JSON.stringify({
                            apiError: err.name,
                            errorMessage: msgs[err.name] || msgs.Unknown
                        })
                    );
                })
            ).json();
        } catch (e) {
            await this.setStateAsync({ error: e.message });
        }

        /** check for fail connection/post */
        if (!postResult) {
            this.setState({ generalError: true });
            return;
        }

        /** get Juror info */
        this.getJurorInfo();
    };

    /** Handle submit button */
    mySubmitHandler = (event) => {
        /** Validate form data */
        event.preventDefault();
        const validation = this.validator.validate(this.state);
        this.setState({ validation });
        this.submitted = true;

        /** if form data validated, get juror information */
        if (validation.isValid) {
            // handle actual form submission here
            this.getJurorInfo();
        }
    };

    /** update state base on the form change */
    myChangeHandler = (event) => {
        const nam = event.target.name;
        const val = event.target.value;
        this.setState({ [nam]: val });
    };

    /** update DOB base on the form change */
    myDOBChangeHandler = (date) => {
        this.setState({ jurorDOB: date });
    };

    /** Juror log out, reset the state */
    logOut() {
        /* Reset the submitted status */
        this.submitted = false;
        /* Reset the state */
        this.setState(this.baseState);
        /* Reset the submitted status */
    }

    render() {
        if (idledOut) {
            return (
                <main>
                    <KioskOutcome idled />
                </main>
            );
        }

        const { jurorDOB, jurorID, jurorDL, isSpecial } = this.state;
        const enabled = jurorDOB && ((jurorID.length > 0 && jurorDL <= 0) || (jurorDL.length > 0 && jurorID.length < 1));
        // const enabled = true;
        const validation = this.submitted // if the form has been submitted at least once
            ? this.validator.validate(this.state) // then check validity every time we render
            : this.state.validation; // otherwise just use what's in state
        /** Check and render general error message */
        if (this.state.generalError) {
            return (
                <main>
                    <ErrorMessage
                        jurorName={`${this.state.juror.firstName} ${this.state.juror.lastName}`}
                        jurorID={this.state.juror.jurorID}
                        jurorReportingDateTime={this.state.juror.reportingDateTime}
                        jurorStatus={this.state.juror.status.jurorStatusAlias}
                        logOut={this.logOut}
                    />
                </main>
            );
        }

        /** juror is authenticated */
        if (this.state.authenticateFlag === 1) {
            /** Send juror to appropriate page base on the juror status ID
       1 - questionnaireIncomplete
       2 - questionnaireComplete
       3 - possibleDeferment
       4 - deferred
       */

            /**  not completed questionaire */
            const { juror } = this.state;
            if (juror.status.jurorStatusAlias === 'questionnaireIncomplete' && !isSpecial) {
                if (!this.state.skipLoginMessage && juror.deniedDefermentCode) {
                    return (
                        <main>
                            <DeniedDeferment
                                jurorName={this.props.jurorName}
                                jurorID={this.props.jurorID}
                                jurorReportingDateTime={this.props.jurorReportingDateTime}
                                logOut={this.props.logOut}
                                goQuestionnaire={() => this.setState({ skipLoginMessage: true })}
                                kioskMode={kioskMode}
                            />
                            <Notifications visible="false" jurorID={juror.jurorID} kioskMode={kioskMode} />
                        </main>
                    );
                }

                // Incomplete questionnaire, send juror to Questionnaire to complete before proceed />
                else
                    return (
                        <main>
                            <Questionnaire
                                key="qq"
                                jurorName={`${this.state.juror.firstName} ${this.state.juror.lastName}`}
                                jurorID={this.state.juror.jurorID}
                                jurorReportingDateTime={this.state.juror.reportingDateTime}
                                jurorStatus={this.state.juror.status.jurorStatusAlias}
                                logOut={this.logOut}
                                dataReview={this.dataReview}
                                kioskMode={kioskMode}
                            />
                        </main>
                    );
            } else {
                /** completed questionnaire,defer, review , send juror to checkIn page */
                return (
                    <main>
                        <CheckIn
                            key="ck"
                            juror={this.state.juror}
                            jurorName={`${this.state.juror.firstName} ${this.state.juror.lastName}`}
                            jurorID={this.state.juror.jurorID}
                            jurorReportingDateTime={this.state.juror.reportingDateTime}
                            jurorStatus={this.state.juror.status.jurorStatusAlias}
                            logOut={this.logOut}
                            kioskMode={kioskMode}
                            isSpecial={isSpecial}
                        />
                    </main>
                );
            }
        } else
            return (
                <div>
                    <MobileHeader kioskMode={kioskMode} />
                    <p />
                    <div className="login-page">
                        <main className="login-box">
                            <h2 style={{ margin: '12pt' }}>Login</h2>
                            <br />
                            <form onSubmit={this.mySubmitHandler}>
                                <span className="help-block">{validation.jurorDOB.message}</span>
                                <FormGroup controlId="jurorDOB">
                                    <p>Please enter Date of Birth:</p>
                                    <DobInput onChange={this.myDOBChangeHandler} />
                                </FormGroup>
                                <br />

                                <label style={{ fontWeight: 'normal' }} htmlFor="login-type">
                                    Log in using{' '}
                                    <select
                                        id="login-type"
                                        className="cta_input"
                                        onChange={(e) => {
                                            this.setState({ loginType: e.target.value, jurorID: '', jurorDL: '' });
                                        }}
                                    >
                                        <option value="jid" default>
                                            Juror ID#
                                        </option>
                                        <option value="dln">Driver&apos;s License#</option>
                                    </select>{' '}
                                    :
                                </label>
                                {this.state.loginType === 'jid' ? (
                                    <>
                                        <span className="help-block">{validation.jurorID.message}</span>
                                        <label htmlFor="jurorID">Juror ID#</label>
                                        <FormGroup controlId="jurorID">
                                            <input
                                                sm="10"
                                                name="jurorID"
                                                maxLength="7"
                                                pattern="\d{7}"
                                                placeholder="Juror ID"
                                                onChange={this.myChangeHandler}
                                                type="text"
                                                className="cta_input"
                                                id="jurorID"
                                                autoComplete="off"
                                            />
                                        </FormGroup>
                                    </>
                                ) : null}
                                {this.state.loginType === 'dln' ? (
                                    <>
                                        <span className="help-block">{validation.jurorDL.message}</span>
                                        <label htmlFor="jurorDL">Driver&apos;s License#</label>
                                        <FormGroup controlId="jurorDL">
                                            <input
                                                sm="10"
                                                name="jurorDL"
                                                maxLength="9"
                                                placeholder="Driver License Number"
                                                onChange={this.myChangeHandler}
                                                type="text"
                                                className="cta_input"
                                                id="jurorDL"
                                                autoComplete="off"
                                            />
                                        </FormGroup>
                                    </>
                                ) : null}
                                <div>
                                    {this.state.authenticateFlag === 0 && (
                                        <span className="help-block">
                                            <p>Your login credentials could not be verified, please try again.</p>
                                        </span>
                                    )}
                                </div>
                                <div>
                                    {this.state.authenticateFlag === -1 && (
                                        <span className="help-block">
                                            <p>System is offline, please try again later.</p>
                                        </span>
                                    )}
                                </div>
                                <br />
                                <Button className="cta_button" block type="submit" disabled={!enabled}>
                                    Login
                                </Button>
                            </form>
                        </main>
                    </div>
                </div>
            );
    }
}
